module.exports = __webpack_public_path__ + "img/cloud_R.98612d7a.png";